import { render, staticRenderFns } from "./MenuCategories.vue?vue&type=template&id=d641ed34&scoped=true"
import script from "./MenuCategories.vue?vue&type=script&lang=js"
export * from "./MenuCategories.vue?vue&type=script&lang=js"
import style0 from "./MenuCategories.vue?vue&type=style&index=0&id=d641ed34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d641ed34",
  null
  
)

export default component.exports